<template>
  <div
    class="tw-rounded-2xl tw-bg-white dark:tw-bg-slate-800 tw-border tw-border-slate-100 dark:tw-border-slate-700 tw-shadow tw-py-3.5 tw-flex tw-flex-col tw-gap-3"
  >
    <div
      class="tw-text-sm tw-text-slate-700 dark:tw-text-slate-50 tw-font-geist tw-font-medium tw-px-4"
    >
      Top Countries
    </div>
    <div class="tw-relative">
      <div>
        <div
          class="tw-flex tw-justify-between tw-items-center tw-text-xs tw-font-medium tw-text-slate-500 tw-px-4 tw-border-b tw-border-slate-100 dark:tw-border-slate-700 tw-py-[5px]"
        >
          <div>Country</div>
          <div class="tw-flex tw-items-center tw-gap-1.5">
            <i class="pi pi-arrow-down tw-text-xs"></i>{{ props.type || "" }}
          </div>
        </div>
        <div>
          <CountryItem
            v-for="country in props.data"
            :key="country.geo"
            :data="country"
            :total-count="totalCount"
          />
        </div>
      </div>
      <LoaderSm v-if="props.loading" />
    </div>
  </div>
</template>

<script setup>
import LoaderSm from "@/components/LoaderSm.vue";
import CountryItem from "./CountryItem.vue";
import { computed } from "vue";

const props = defineProps(["data", "loading", "type"]);

const totalCount = computed(() =>
  props.data.reduce((sum, item) => sum + item.count, 0)
);
</script>
